/**
 * Decode special characters in JSON
 *
 * @param JSON {json_string}
 * @return string
 *
 * @see adapted from: https://stackoverflow.com/questions/7394748/whats-the-right-way-to-decode-a-string-that-has-special-html-entities-in-it/7394787#7394787
 */
export const cleanJSON = ( string ) => {

    const $html = document.createElement( 'textarea' );
    let clean_json = '';

    string = string.replace( /\/>n/g, '/>' );
    string = string.replace( /u00a0/g, ' ' );
    string = string.replace( /\\r\\n/g, '<br>' );
    string = string.replace( /\\n/g, '' );
    $html.innerHTML = string;
    clean_json = JSON.parse( $html.value );

    return ( clean_json ? clean_json : string );

}



// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/utils.js